
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Logger } from '@aws-amplify/core';
import * as L from 'leaflet';

const logger = new Logger('LeafletMapLayerGroup');

@Component({ name: 'LeafletMapLayerGroup' })
export default class LeafletMapLayerGroup extends Vue {
  @Prop() map!: L.Map;
  @Prop() name!: string;

  ready = false;
  layerGroup: L.LayerGroup = new L.LayerGroup();
  mounted() {
    this.layerGroup.addTo(this.map);
    this.ready = true;
    logger.info(`LayerGroup ${this.name} Added`);
  }
}
